import {Module} from "../index";
import {Negotiator, StaffMember} from "@/modules/staff/entity";
import StaffMemberNegotiation from './components/StaffMemberNegotiation.vue';
import StaffMemberLink from './components/StaffMemberLink.vue';
import {StaffMemberTransferator} from "@/modules/staff/services/StaffMemberTransferator";
import {StaffNegotiationStarter} from "@/modules/staff/services/StaffNegotiationStarter";
import {StaffNegotiationCloser} from "@/modules/staff/services/StaffNegotiationCloser";
import {TYPES} from "@/modules/diplomacy/types";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {NegotiationComponentManager} from "@/modules/diplomacy/services/NegotiationComponentManager";
import {GameCreationSubscriber} from "@/modules/staff/subscribers/GameCreationSubscriber";
import {LinkComponentManager} from "@/modules/vue/services/LinkComponentManager";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {NegotiatorFactory} from "@/modules/staff/services/factories/NegotiatorFactory";
import {StaffNegotiation} from "@/modules/staff/entity/StaffNegotiation";
import {SeasonEvaluationSubscriber} from "@/modules/staff/subscribers/SeasonEvaluationSubscriber";
import {MarketValueCalculator} from "./services/MarketValueCalculator";
import {StaffMemberWageEventSubscriber} from "@/modules/staff/subscribers/StaffMemberWageEventSubscriber";
import {AbstractStaffMemberFactory} from "@/modules/staff/services/factories/AbstractStaffMemberFactory";
import {TYPES as STAFF_TYPES} from './types';

export class StaffModule extends Module {
  messages = messages;
  routes = routes;

  eventSubscribers = [
    GameCreationSubscriber,
    SeasonEvaluationSubscriber,
    StaffMemberWageEventSubscriber,
  ];

  public entities = [
    StaffMember,
    Negotiator,
    StaffNegotiation,
  ];

  protected register() {
    super.register();

    this.app.bind<NegotiationCloserInterface>(TYPES.NegotiationCloser).to(StaffNegotiationCloser);

    this.app.bind<NegotiatorFactory>(NegotiatorFactory).to(NegotiatorFactory);
    this.app.bind<AbstractStaffMemberFactory>(STAFF_TYPES.StaffMemberFactory).to(NegotiatorFactory);

    this.app.bind<StaffMemberTransferator>(StaffMemberTransferator).to(StaffMemberTransferator);
    this.app.bind<StaffNegotiationStarter>(StaffNegotiationStarter).to(StaffNegotiationStarter);
    this.app.bind<MarketValueCalculator>(MarketValueCalculator).to(MarketValueCalculator);
  }

  boot() {
    super.boot();

    this.app.get(NegotiationComponentManager).addItem({
      class: StaffNegotiation,
      component: StaffMemberNegotiation,
    });

    this.app.get(LinkComponentManager).addItem({
      class: StaffMember,
      component: StaffMemberLink,
    });
  }
}
